const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/

const formmasks = {
  money: ["#,##", "##,##", "###,##", "####,##", "#####,##", "######,##"],
  cpf: "###.###.###-##",
  cnpj: "XX.XXX.XXX/XXXX-##",
  number: "####################",
  countrycode: ['+##'],
  ddd: ['(##)'],
  cpfcnpj: ['###.###.###-##', 'XX.XXX.XXX/XXXX-##'],
  phoneWithDDD: ['(##) ####-####', '(##) #####-####'],
  telefone: ['####-####', '#####-####'],
  celular: ['#####-####'],
  cep: ['#####-###'],
  date: ['##/##/####'],
  unmask: text => {
    return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text
  }
}

export {
  formmasks
}
